import { AutocompleteField } from "../../formComponents/Autocomplete/AutocompleteField";
import { CheckboxField } from "../../formComponents/Checkbox/CheckboxField";
import { DatePickerField } from "../../formComponents/DatePicker/DatePickerField";
import { DynamicPropertiesField } from "../../formComponents/DynamicProperties/DynamicPropertiesField";
import { FileContentsField } from "../../formComponents/FileContents/FileContentsField";
import { HiddenCheckboxField } from "../../formComponents/HiddenCheckbox/HiddenCheckboxField";
import { HiddenValueField } from "../../formComponents/HiddenValue/HiddenValueField";
import { InputGeneratorField } from "../../formComponents/InputGenerator/InputGeneratorField";
import { MultiSelectDynamicField } from "../../formComponents/MultiSelectDynamic/MultiSelectDynamicField";
import { NumberField } from "../../formComponents/Number/NumberField";
import { ProfileSelectorField } from "../../formComponents/ProfileSelector/ProfileSelectorField";
import { ReadOnlyCheckField } from "../../formComponents/ReadOnlyCheck/ReadOnlyCheckField";
import { SelectDynamicField } from "../../formComponents/SelectDynamic/SelectDynamicField";
import { SiteIdCopyGeneratorField } from "../../formComponents/SiteIdGenerator/SiteIdCopyGeneratorField";
import { SiteIdGeneratorField } from "../../formComponents/SiteIdGenerator/SiteIdGeneratorField";
import { TerminalIdCopyGeneratorField } from "../../formComponents/TerminalIdGenerator/TerminalIdCopyGeneratorField";
import { TerminalIdGeneratorField } from "../../formComponents/TerminalIdGenerator/TerminalIdGeneratorField";
import { TerminalsTextareaField } from "../../formComponents/TerminalsTextarea/TerminalsTextareaField";
import { TextField } from "../../formComponents/Text/TextField";
import { TextareaField } from "../../formComponents/Textarea/TextareaField";
import { TextTemplatingField } from "../../formComponents/TextTemplating/TextTemplatingField";
import { TimePickerField } from "../../formComponents/TimePicker/TimePickerField";
import { UploadFileField } from "../../formComponents/UploadFile/UploadFileField";
import type { FieldMethod } from "../../types/types";
import { FormComponent } from "../../types/types";

export const HorizontalFormFieldsMap: Record<FormComponent, FieldMethod | null> = {
    [FormComponent.DATA_GROUP_USERS_TABLE]: null,
    [FormComponent.DATA_GROUP_IDM_USERS_TABLE]: null,
    [FormComponent.DYNAMIC_PROPERTY_GROUP_PROPERTIES_TABLE]: null,
    [FormComponent.SITES_TABLE_VIEW]: null,
    [FormComponent.VIRTUAL_SITES_TABLE]: null,
    [FormComponent.SELECT_DYNAMIC]: SelectDynamicField,
    [FormComponent.PROFILE_SELECTOR]: ProfileSelectorField,
    [FormComponent.CHECK_BOX]: CheckboxField,
    [FormComponent.HIDDEN_CHECK_BOX]: HiddenCheckboxField,
    [FormComponent.HIDDEN_INPUT]: HiddenValueField,
    [FormComponent.READ_ONLY_CHECK]: ReadOnlyCheckField,
    [FormComponent.TIME_PICKER]: TimePickerField,
    [FormComponent.DATE_PICKER]: DatePickerField,
    [FormComponent.TEXT_AREA]: TextareaField,
    [FormComponent.TEXT_TEMPLATING]: TextTemplatingField,
    [FormComponent.TEXT]: TextField,
    [FormComponent.NUMBER]: NumberField,
    [FormComponent.AUTOCOMPLETE]: AutocompleteField,
    [FormComponent.MULTI_SELECT_DYNAMIC]: MultiSelectDynamicField,
    [FormComponent.INPUT_GENERATOR]: InputGeneratorField,
    [FormComponent.UPLOAD_FILE]: UploadFileField,
    [FormComponent.FILE_CONTENTS]: FileContentsField,
    [FormComponent.NO_ELEMENT]: null,
    [FormComponent.ACCEPT_TYPE_SELECTOR]: null,
    [FormComponent.CONTRACTS_TERMINALS_TABLE]: null,
    [FormComponent.CONTRACTS_APP_PROFILES_TABLE]: null,
    [FormComponent.CONTRACTS_VIRTUAL_APP_PROFILES_TABLE]: null,
    [FormComponent.VIRTUAL_ACQUIRERS_PHYSICAL_ACQUIRERS_TABLE]: null,
    [FormComponent.APPLICATIONS_PROFILE_CARD_DEFINITIONS_TABLE]: null,
    [FormComponent.ACQUIRERS_OPERATORS_TABLE]: null,
    [FormComponent.SITES_CONTRACTS_TABLE]: null,
    [FormComponent.APPLICATIONS_PROFILE_PROMPT_DATA]: null,
    [FormComponent.DYNAMIC_PROPERTIES]: DynamicPropertiesField,
    [FormComponent.PARAMETERS_TABLE]: null,
    [FormComponent.TERMINAL_ID_GENERATOR]: TerminalIdGeneratorField,
    [FormComponent.TERMINAL_ID_COPY_GENERATOR]: TerminalIdCopyGeneratorField,
    [FormComponent.SITE_ID_GENERATOR]: SiteIdGeneratorField,
    [FormComponent.SITE_ID_COPY_GENERATOR]: SiteIdCopyGeneratorField,
    [FormComponent.TERMINAL_CONTRACTS_TABLE]: null,
    [FormComponent.TERMINAL_HOST_TERMINAL]: null,
    [FormComponent.CARD_DEFINITIONS_TABLE]: null,
    [FormComponent.CARD_ATTRIBUTES_TABLE]: null,
    [FormComponent.ACQUIRERS_CONTRACTS_TABLE]: null,
    [FormComponent.EMV_KERNEL_EMV_CONFIGURATIONS_TABLE]: null,
    [FormComponent.EMV_KERNEL_CA_PUBLIC_KEYS_TABLE]: null,
    [FormComponent.EMV_KERNEL_AID_PREFERENCES_TABLE]: null,
    [FormComponent.EMV_KERNEL_AID_PREFERENCES_CLESS_TABLE]: null,
    [FormComponent.APPLICATION_CONFIGURATIONS_VALIDATIONS_EDIT]: null,
    [FormComponent.APPLICATION_CONFIGURATIONS_DEFAULT_VALUE_EDIT]: null,
    [FormComponent.CAMPAIGN_TERMINALS_SELECTABLE_TABLE]: null,
    [FormComponent.TERMINAL_TO_CAMPAIGN_TABLE]: null,
    [FormComponent.VAT_CODE_VAT_VALUES_TABLE]: null,
    [FormComponent.CARD_COMBINATIONS]: null,
    [FormComponent.PRODUCT_PROFILE_PRODUCTS]: null,
    [FormComponent.CARD_TYPES_MAPPING_TABLE]: null,
    [FormComponent.DISPLAY_TEXT]: null,
    [FormComponent.TERMINALS_TEXTAREA]: TerminalsTextareaField,
    [FormComponent.CAMPAIGN_TERMINALS_VIEW_TABLE]: null,
    [FormComponent.SITES_VIRTUAL_SITES_TABLE]: null,
    [FormComponent.ORG_UNITS_PRODUCTS_PROFILE]: null,
};
